(function () {
  'use strict';

  var runtimeKey = '__nadaStorePopupsRuntime';
  var existingRuntime = window[runtimeKey];

  if (existingRuntime) {
    existingRuntime.register();
    return;
  }

  var controllers = new Map();
  var entryExitGap = 1500;

  function hash(value) {
    var result = 2166136261;
    var index;

    for (index = 0; index < value.length; index += 1) {
      result ^= value.charCodeAt(index);
      result = Math.imul(result, 16777619);
    }

    return (result >>> 0).toString(36);
  }

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function getStorage(name) {
    try {
      return window[name];
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function isValidDate(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    var date;

    if (!match) {
      return false;
    }

    date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));

    return (
      date.getUTCFullYear() === Number(match[1]) &&
      date.getUTCMonth() === Number(match[2]) - 1 &&
      date.getUTCDate() === Number(match[3])
    );
  }

  function localDateKey(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  function scheduleIsActive(popup, designMode) {
    var start = popup.dataset.popupStart || '';
    var end = popup.dataset.popupEnd || '';
    var popupRoot = popup.closest('[data-store-popup-root]');
    var currentDate = popupRoot ? popupRoot.dataset.popupCurrentDate || '' : '';

    if (designMode || popup.dataset.popupDisplayMode !== 'scheduled') {
      return true;
    }

    if (!isValidDate(start) || !isValidDate(end) || start > end || !isValidDate(currentDate)) {
      return false;
    }

    return currentDate >= start && currentDate <= end;
  }

  function frequencyAllows(popup, designMode) {
    var frequency = popup.dataset.popupFrequency;
    var campaignKey = hash(popup.dataset.popupCampaignSource || popup.dataset.storePopup);
    var storageKey = 'nada-store-popup:' + popup.dataset.storePopup + ':' + campaignKey;
    var record;
    var elapsed;

    if (designMode || frequency === 'always') {
      return true;
    }

    if (frequency === 'session') {
      return !storageGet(getStorage('sessionStorage'), storageKey);
    }

    record = storageGet(getStorage('localStorage'), storageKey);

    if (!record) {
      return true;
    }

    if (frequency === '1') {
      return record !== localDateKey(new Date());
    }

    elapsed = Date.now() - Number(record);

    return !Number.isFinite(elapsed) || elapsed >= Number(frequency) * 86400000;
  }

  function markFrequency(popup, designMode) {
    var frequency = popup.dataset.popupFrequency;
    var campaignKey = hash(popup.dataset.popupCampaignSource || popup.dataset.storePopup);
    var storageKey = 'nada-store-popup:' + popup.dataset.storePopup + ':' + campaignKey;

    if (designMode || frequency === 'always') {
      return;
    }

    if (frequency === 'session') {
      storageSet(getStorage('sessionStorage'), storageKey, String(Date.now()));
      return;
    }

    if (frequency === '1') {
      storageSet(getStorage('localStorage'), storageKey, localDateKey(new Date()));
      return;
    }

    storageSet(getStorage('localStorage'), storageKey, String(Date.now()));
  }

  function getFocusable(dialog) {
    return Array.prototype.slice.call(
      dialog.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function PopupController(root) {
    this.root = root;
    this.popups = Array.prototype.slice.call(root.querySelectorAll('[data-store-popup]'));
    this.active = null;
    this.previousActiveElement = null;
    this.inertedElements = [];
    this.entryTimer = null;
    this.entryClosedAt = 0;
    this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
    this.boundMouseOut = this.handleMouseOut.bind(this);
    this.boundKeyDown = this.handleKeyDown.bind(this);
    this.boundClick = this.handleClick.bind(this);

    root.addEventListener('click', this.boundClick);
    document.addEventListener('mouseout', this.boundMouseOut);

    if (this.designMode) {
      return;
    }

    this.scheduleEntry();
  }

  PopupController.prototype.scheduleEntry = function () {
    var entry = this.getPopup('entry');
    var delay;

    if (!entry || !scheduleIsActive(entry, this.designMode) || !frequencyAllows(entry, this.designMode)) {
      return;
    }

    delay = Math.max(0, Number(entry.dataset.popupDelay || 0)) * 1000;
    this.entryTimer = window.setTimeout(
      function () {
        this.open(entry);
      }.bind(this),
      delay
    );
  };

  PopupController.prototype.getPopup = function (type) {
    return this.popups.find(function (popup) {
      return popup.dataset.storePopup === type;
    });
  };

  PopupController.prototype.handleMouseOut = function (event) {
    var exit = this.getPopup('exit');

    if (
      !exit ||
      this.designMode ||
      this.active ||
      this.entryTimer === null && this.entryClosedAt && Date.now() - this.entryClosedAt < entryExitGap ||
      !window.matchMedia('(hover: hover) and (pointer: fine)').matches ||
      event.relatedTarget ||
      event.clientY > 0
    ) {
      return;
    }

    if (scheduleIsActive(exit, this.designMode) && frequencyAllows(exit, this.designMode)) {
      this.open(exit);
    }
  };

  PopupController.prototype.handleClick = function (event) {
    var closeButton = event.target.closest('[data-popup-close]');
    var backdrop = event.target.closest('[data-popup-backdrop]');

    if (closeButton) {
      event.preventDefault();
      this.close();
      return;
    }

    if (backdrop && this.active && this.active.dataset.popupCloseOutside === 'true') {
      this.close();
    }
  };

  PopupController.prototype.handleKeyDown = function (event) {
    var focusable;
    var first;
    var last;

    if (!this.active) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    focusable = getFocusable(this.active.querySelector('[data-popup-dialog]'));
    first = focusable[0];
    last = focusable[focusable.length - 1];

    if (!first) {
      event.preventDefault();
      this.active.querySelector('[data-popup-dialog]').focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  PopupController.prototype.loadImage = function (popup) {
    var image = popup.querySelector('[data-popup-image]');

    if (!image || image.getAttribute('src')) {
      return;
    }

    image.setAttribute('src', image.dataset.src);
    image.setAttribute('srcset', image.dataset.srcset);
  };

  PopupController.prototype.setBackgroundInert = function () {
    var wrapper = this.root.closest('[id^="shopify-section-"]') || this.root;
    var children = Array.prototype.slice.call(document.body.children);

    this.inertedElements = children.filter(function (child) {
      return child !== wrapper && !child.contains(this.root);
    }, this);

    this.inertedElements.forEach(function (element) {
      element.dataset.storePopupPreviousInert = element.inert ? 'true' : 'false';
      element.dataset.storePopupPreviousAriaHidden = element.getAttribute('aria-hidden') || '';
      element.inert = true;
      element.setAttribute('aria-hidden', 'true');
    });
  };

  PopupController.prototype.restoreBackground = function () {
    this.inertedElements.forEach(function (element) {
      if (element.dataset.storePopupPreviousInert !== 'true') {
        element.inert = false;
      }

      if (element.dataset.storePopupPreviousAriaHidden) {
        element.setAttribute('aria-hidden', element.dataset.storePopupPreviousAriaHidden);
      } else {
        element.removeAttribute('aria-hidden');
      }

      delete element.dataset.storePopupPreviousInert;
      delete element.dataset.storePopupPreviousAriaHidden;
    });

    this.inertedElements = [];
  };

  PopupController.prototype.open = function (popup) {
    var dialog;
    var closeButton;

    if (!popup || (this.active && this.active === popup)) {
      return;
    }

    if (this.active) {
      this.close();
    }

    if (popup.dataset.storePopup === 'exit' && this.entryClosedAt && Date.now() - this.entryClosedAt < entryExitGap) {
      return;
    }

    if (!this.designMode && (!scheduleIsActive(popup, false) || !frequencyAllows(popup, false))) {
      return;
    }

    if (this.entryTimer !== null) {
      window.clearTimeout(this.entryTimer);
      this.entryTimer = null;
    }

    markFrequency(popup, this.designMode);
    this.loadImage(popup);
    this.previousActiveElement = document.activeElement;
    this.active = popup;
    dialog = popup.querySelector('[data-popup-dialog]');
    closeButton = popup.querySelector('[data-popup-close]');

    popup.hidden = false;
    popup.classList.add('is-open');
    this.setBackgroundInert();
    document.documentElement.classList.add('store-popups-lock-scroll');
    document.body.classList.add('store-popups-lock-scroll');
    dialog.addEventListener('keydown', this.boundKeyDown);

    window.requestAnimationFrame(function () {
      if (closeButton) {
        closeButton.focus();
      } else {
        dialog.focus();
      }
    });
  };

  PopupController.prototype.close = function () {
    var popup = this.active;
    var dialog;

    if (!popup) {
      return;
    }

    dialog = popup.querySelector('[data-popup-dialog]');
    dialog.removeEventListener('keydown', this.boundKeyDown);
    popup.classList.remove('is-open');
    popup.hidden = true;
    this.active = null;
    this.restoreBackground();
    document.documentElement.classList.remove('store-popups-lock-scroll');
    document.body.classList.remove('store-popups-lock-scroll');

    if (popup.dataset.storePopup === 'entry') {
      this.entryClosedAt = Date.now();
    }

    if (this.previousActiveElement && typeof this.previousActiveElement.focus === 'function') {
      this.previousActiveElement.focus();
    }

    this.previousActiveElement = null;
  };

  PopupController.prototype.preview = function () {
    var entry = this.getPopup('entry');
    var exit = this.getPopup('exit');

    this.open(entry || exit);
  };

  PopupController.prototype.destroy = function () {
    if (this.entryTimer !== null) {
      window.clearTimeout(this.entryTimer);
    }

    this.close();
    this.root.removeEventListener('click', this.boundClick);
    document.removeEventListener('mouseout', this.boundMouseOut);
  };

  function findRoot(target) {
    if (!target) {
      return null;
    }

    return target.matches('[data-store-popup-root]')
      ? target
      : target.querySelector('[data-store-popup-root]');
  }

  var runtime = {
    register: function () {
      document.querySelectorAll('[data-store-popup-root]').forEach(function (root) {
        if (!controllers.has(root)) {
          controllers.set(root, new PopupController(root));

          if (window.Shopify && window.Shopify.designMode) {
            controllers.get(root).preview();
          }
        }
      });
    },
    unload: function (target) {
      var root = findRoot(target);
      var controller = root && controllers.get(root);

      if (controller) {
        controller.destroy();
        controllers.delete(root);
      }
    },
    select: function (target) {
      var root = findRoot(target);
      var controller = root && controllers.get(root);

      if (controller && window.Shopify && window.Shopify.designMode) {
        controller.preview();
      }
    }
  };

  window[runtimeKey] = runtime;
  document.addEventListener('shopify:section:load', function (event) {
    runtime.register(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    runtime.unload(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    runtime.select(event.target);
  });
  runtime.register();
})();
